import AddAddressModal from '~/components/modals/person/AddAddressModal/AddAddressModal.vue';
import AddAlternateNameModal from '~/components/modals/person/AddAlternateNameModal/AddAlternateNameModal.vue';
import AddContact from '~/components/modals/person/AddContact/AddContact.vue';
import AddEmailModal from '~/components/modals/person/AddEmailModal/AddEmailModal.vue';
import AddPhoneModal from '~/components/modals/person/AddPhoneModal/AddPhoneModal.vue';
import AddRelativeModal from '~/components/modals/person/AddRelativeModal/AddRelativeModal.vue';
import AssignLicenseModal from '~/components/modals/person/AssignLicenseModal/AssignLicenseModal.vue';
import BlockContactModal from '~/components/modals/person/BlockContactModal/BlockContactModal.vue';
import CallConnectedModal from '~/components/modals/person/CallConnectedModal/CallConnectedModal.vue';
import CameraCaptureModal from '~/components/modals/person/CameraCapture/CameraCaptureModal.vue';
import CreateGroupChat from '~/components/modals/person/CreateGroupChat/CreateGroupChat.vue';
import DeleteAccount from '~/components/modals/person/DeleteAccount/DeleteAccount.vue';
import EditContact from '~/components/modals/person/EditContact/EditContact.vue';
import EditDobModal from '~/components/modals/person/EditDobModal/EditDobModal.vue';
import EditNameModal from '~/components/modals/person/EditNameModal.vue';
import EmailVerification from '~/components/modals/person/EmailVerification/EmailVerification.vue';
import GiftCertModal from '~/components/modals/person/GiftCertModal/GiftCertModal.vue';
import GiftCertPurchased from '~/components/modals/person/GiftCertPurchasedModal/GiftCertPurchased.vue';
import ImageViewerModal from '~/components/modals/person/ImageViewerModal/ImageViewerModal.vue';
import IncomingCallModal from '~/components/modals/person/IncomingCallModal/IncomingCallModal.vue';
import OutgoingCallModal from '~/components/modals/person/OutgoingCallModal/OutgoingCallModal.vue';
import PhoneVerification from '~/components/modals/person/PhoneVerification/PhoneVerification.vue';

import RemoveContactModal from '~/components/modals/person/RemoveContactModal/RemoveContactModal.vue';
import RemoveFromVault from '~/components/modals/person/RemoveFromVault/RemoveFromVault.vue';
import RequestDeletionGuide from '~/components/modals/person/RequestDeletionGuide.vue';
import RequestNewCompany from '~/components/modals/person/RequestNewCompany.vue';
import SubmitResearchRequest from '~/components/modals/person/SubmitResearchRequest.vue';
import StripePaymentModal from '~/components/modals/person/UpdatePaymentInfoModal/StripePaymentModal.vue';
import UpdatePaymentInfoModal from '~/components/modals/person/UpdatePaymentInfoModal/UpdatePaymentInfoModal.vue';
import UpdateTagModal from '~/components/modals/person/UpdateTagModal/UpdateTagModal.vue';
import UploadFile from '~/components/modals/person/UploadFileModal/UploadFile.vue';
import ExposureSideBar from '~/components/side-bar/person/ExposureSideBar.vue';
import ExposureSources from '~/components/modals/person/ExposureSources/ExposureSources.vue';
import type { Contact } from './person/contacts';
import type { License } from './person/person';

//admin
import AdminLogoutModal from '~/components/modals/admin/AdminLogoutModal/AdminLogoutModal.vue';
import ViewCompany from '~/components/side-bar/admin/companies/ViewCompany.vue';
import ViewAdvisory from '~/components/side-bar/admin/threat-research/ViewAdvisory.vue';

//dev
import type { DialogProps } from 'primevue/dialog';
import type { DynamicDialogInstance, DynamicDialogOptions } from 'primevue/dynamicdialogoptions';
import SelectDevBranch from '~/components/modals/dev/SelectDevBranch.vue';
import DeletionRequestModal from '~/components/modals/person/DeletionRequestModal/DeletionRequestModal.vue';
import PurchaseLicensesModal from '~/components/modals/person/LicenseModals/PurchaseLicensesModal.vue';
import RefundLicenseModal from '~/components/modals/person/LicenseModals/RefundLicenseModal.vue';
import type { AssignLicenseModalData, PurchaseLicenseModalData } from '~/types/licenses/licenses';

export interface PbDialogProps extends DialogProps {
    onClose?: () => void;
}

export enum ModalNames {
    // Personal modals
    CREATE_GROUP_CHAT,
    GIFTCERT,
    GIFTCERT_PURCHASED,
    UPDATE_PAYMENT_INFO,
    EMAIL_VERIFICATION,
    PHONE_VERIFICATION,
    ADD_CONTACT,
    EDIT_CONTACT,
    EXPOSURE_SIDEBAR,
    UPLOAD_FILE,
    REQUEST_NEW_COMPANY,
    DELETION_GUIDE,
    DELETION_REQUEST,
    UPDATE_TAG,
    BLOCK_CONTACT,
    REMOVE_CONTACT,
    INCOMING_CALL,
    OUTGOING_CALL,
    OUTGOING_CALL_CONNECTED,
    REMOVE_FROM_VAULT,
    ADD_EMAIL,
    ADD_PHONE,
    ADD_ALTERNATE_NAME,
    EDIT_NAME,
    ADD_ADDRESS,
    EDIT_DOB,
    ADD_RELATIVE,
    STRIPE_PAYMENT,
    SUBSCRIPTION_AUTH,
    IMAGE_VIEWER,
    CAMERA_CAPTURE,
    ASSIGN_LICENSE,
    SUBMIT_RESEARCH_REQUEST,
    REFUND_LICENSE,
    DELETE_ACCOUNT,
    EXPOSURE_SOURCES,
    
    // License modals
    PURCHASE_LICENSES,
    PERSON_SUBSCRIBE,
    
    // Dev modals
    SELECT_DEV_BRANCH,
    
    // Admin modals
    ADMIN_LOGOUT,
    VIEW_ADVISORY,
    VIEW_COMPANY,
}



// Type mapping for modal data requirements
export interface ModalDataMap {
    [ModalNames.PURCHASE_LICENSES]: PurchaseLicenseModalData;
    [ModalNames.REFUND_LICENSE]: License;
    [ModalNames.EMAIL_VERIFICATION]: { email: string; fromExposure?: boolean; exposureData?: any };
    [ModalNames.PHONE_VERIFICATION]: { phone_number: string; country_code: string; method: string; fromExposure?: boolean; exposureData?: any };
    [ModalNames.ADD_PHONE]: { phone_number?: string; country_code?: string; method?: string; fromExposure?: boolean; exposureData?: any };
    [ModalNames.ADD_EMAIL]: { email?: string; fromExposure?: boolean; exposureData?: any };
    [ModalNames.ADD_ADDRESS]: { address?: any; fromExposure?: boolean; exposureData?: any };
    [ModalNames.ADD_CONTACT]: { contact?: any; fromExposure?: boolean; exposureData?: any };
    [ModalNames.ADD_ALTERNATE_NAME]: { fullName?: string; fromExposure?: boolean; exposureData?: any };
    [ModalNames.IMAGE_VIEWER]: { imageUrl: string; altText?: string };
    [ModalNames.ASSIGN_LICENSE]: AssignLicenseModalData;
    [ModalNames.BLOCK_CONTACT]: { contactId: string; contactName: string };
    [ModalNames.REMOVE_CONTACT]: { contactId: string; contactName: string };
    [ModalNames.REMOVE_FROM_VAULT]: { itemId: string; itemType: string };
    [ModalNames.UPDATE_TAG]: { tagId: string; currentName: string };
    [ModalNames.VIEW_ADVISORY]: { advisoryId: string };
    [ModalNames.DELETION_REQUEST]: { company: { id: number; name: string; type: string; logo: string; url: string; slug: string } };
    [ModalNames.VIEW_COMPANY]: { companyId: string };
    [ModalNames.EXPOSURE_SOURCES]: { exposures: any[] };
    [ModalNames.EDIT_CONTACT]: { contact: Contact };
}

// Helper type to get data type for a specific modal
export type ModalData<T extends ModalNames> = T extends keyof ModalDataMap ? ModalDataMap[T] : never;

// Helper type for modals that don't require data
export type ModalWithoutData = Exclude<ModalNames, keyof ModalDataMap> | ModalNames.ADD_PHONE;

// Type for dialog data that extends PrimeVue's dialog data type
export type DialogData<T extends ModalNames> = T extends keyof ModalDataMap ? ModalDataMap[T] : any;

// Modal component mapping for better autocomplete and navigation
export const ModalComponents = {
    [ModalNames.PHONE_VERIFICATION]: () => PhoneVerification,
    [ModalNames.EMAIL_VERIFICATION]: () => EmailVerification,
    [ModalNames.ADD_PHONE]: () => AddPhoneModal,
    [ModalNames.ADD_EMAIL]: () => AddEmailModal,
    [ModalNames.ADD_ADDRESS]: () => AddAddressModal,
    [ModalNames.ADD_ALTERNATE_NAME]: () => AddAlternateNameModal,
    [ModalNames.EDIT_NAME]: () => EditNameModal,
    [ModalNames.EDIT_DOB]: () => EditDobModal,
    [ModalNames.ADD_RELATIVE]: () => AddRelativeModal,
    [ModalNames.ADD_CONTACT]: () => AddContact,
    [ModalNames.EDIT_CONTACT]: () => EditContact,
    [ModalNames.BLOCK_CONTACT]: () => BlockContactModal,
    [ModalNames.REMOVE_CONTACT]: () => RemoveContactModal,
    [ModalNames.REMOVE_FROM_VAULT]: () => RemoveFromVault,
    [ModalNames.UPDATE_TAG]: () => UpdateTagModal,
    [ModalNames.UPDATE_PAYMENT_INFO]: () => UpdatePaymentInfoModal,
    [ModalNames.STRIPE_PAYMENT]: () => StripePaymentModal,
    [ModalNames.GIFTCERT]: () => GiftCertModal,
    [ModalNames.GIFTCERT_PURCHASED]: () => GiftCertPurchased,
    [ModalNames.CREATE_GROUP_CHAT]: () => CreateGroupChat,
    [ModalNames.UPLOAD_FILE]: () => UploadFile,
    [ModalNames.REQUEST_NEW_COMPANY]: () => RequestNewCompany,
    [ModalNames.DELETION_GUIDE]: () => RequestDeletionGuide,
    [ModalNames.DELETION_REQUEST]: () => DeletionRequestModal,
    [ModalNames.INCOMING_CALL]: () => IncomingCallModal,
    [ModalNames.OUTGOING_CALL]: () => OutgoingCallModal,
    [ModalNames.OUTGOING_CALL_CONNECTED]: () => CallConnectedModal,
    [ModalNames.IMAGE_VIEWER]: () => ImageViewerModal,
    [ModalNames.CAMERA_CAPTURE]: () => CameraCaptureModal,
    [ModalNames.ASSIGN_LICENSE]: () => AssignLicenseModal,
    [ModalNames.SUBMIT_RESEARCH_REQUEST]: () => SubmitResearchRequest,
    [ModalNames.PURCHASE_LICENSES]: () => PurchaseLicensesModal,
    [ModalNames.EXPOSURE_SIDEBAR]: () => ExposureSideBar,
    [ModalNames.SELECT_DEV_BRANCH]: () => SelectDevBranch,
    [ModalNames.ADMIN_LOGOUT]: () => AdminLogoutModal,
    [ModalNames.VIEW_ADVISORY]: () => ViewAdvisory,
    [ModalNames.VIEW_COMPANY]: () => ViewCompany,
    [ModalNames.REFUND_LICENSE]: () => RefundLicenseModal,
    [ModalNames.DELETE_ACCOUNT]: () => DeleteAccount,
    [ModalNames.EXPOSURE_SOURCES]: () => ExposureSources,
} as const;

// Type for getting the component type from a modal name
export type ModalComponent<T extends ModalNames> = T extends keyof typeof ModalComponents ? ReturnType<typeof ModalComponents[T]> : never; 


export type TypedDialogOptions<T> = Omit<DynamicDialogOptions, 'data'> & { data: T };
export type TypedDialogInstance<T> = Omit<DynamicDialogInstance, 'data' | 'options'> & {
  data: T;
  options: TypedDialogOptions<T>;
};

// Helper type to get data type for a specific modal component
export type ModalDataForComponent<T extends keyof typeof ModalComponents> = 
  T extends keyof ModalDataMap ? ModalDataMap[T] : never;